import React, { Component } from 'react';
import {
  Grid,
  Paper,
  Typography,
  Button,
  CircularProgress
} from '@material-ui/core';
import Input from '../../../common/Input';

import DeleteIcon from '@material-ui/icons/Delete';
import Select from '../../../common/Select';
import { secondary } from '../../../admin/AdminTheme';
import { Link } from 'gatsby';
import { Query, Mutation } from 'react-apollo';
import { ADMIN_GET_TEAMSTORE } from '../../gql/admin-queries';
import {
  ADMIN_CREATE_PRODUCT_SALESCHANNEL,
  ADMIN_DELETE_PRODUCT_SALESCHANNEL,
  ADMIN_UPDATE_PRODUCT_SALESCHANNEL
} from '../../gql/admin-mutations';
import { getTextFromLanguage } from '../../../../helper/languageHelper';
import { defaultLanguage } from '../../../../helper/config';
import _orderBy from 'lodash/orderBy';
import Imgix from 'react-imgix';
import { MEDIA_CDN_URL, IMGIX_URL } from '../../../../../brikl-config';
class TeamstoreAssignedProducts extends Component {
  state = {
    selectedSalesChannelId: null,
    loading: false
  };
  render() {
    const { teamstoreId, teamstore, defaultLanguage, shopId } = this.props;
    return (
      <Mutation
        mutation={ADMIN_UPDATE_PRODUCT_SALESCHANNEL}
        update={(cache, { data: { updateProductSalesChannel } }) => {
          if (updateProductSalesChannel) {
            const data = cache.readQuery({
              query: ADMIN_GET_TEAMSTORE,
              variables: { id: teamstore.id }
            });
            data.teamstore.products.edges = data.teamstore.products.edges.map(
              c =>
                c.node.product.id === pc.node.product.id
                  ? {
                      ...c,
                      updateProductSalesChannel
                    }
                  : c
            );
            cache.writeQuery({
              query: ADMIN_GET_TEAMSTORE,
              variables: { id: teamstore.id },
              data
            });
          }
        }}
      >
        {(updateProductSalesChannel, { data, loading, error }) => {
          return (
            <Grid container>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Paper elevation={0}>
                  <Grid container>
                    {this.state.loading === true ? (
                      <CircularProgress />
                    ) : teamstore.products.edges ? (
                      _orderBy(
                        teamstore.products.edges,
                        ['node.sortOrder'],
                        ['asc']
                      ).map(pc =>
                        pc.node.product.id ? (
                          <Grid
                            key={'tpc' + pc.node.product.id}
                            container
                            alignItems={'center'}
                            spacing={1}
                          >
                            <Grid
                              item
                              xs={2}
                              style={{
                                cursor: 'pointer',
                                padding: '8px 0px',
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Input
                                placeholder="Sort order"
                                id="outlined-logo"
                                margin="normal"
                                type={'text'}
                                value={pc.node.sortOrder}
                                onChange={e => {
                                  updateProductSalesChannel({
                                    optimisticResponse: {
                                      __typename: 'Mutation',
                                      updateProductSalesChannel: {
                                        ...pc.node,
                                        sortOrder: e.target.value
                                          ? parseFloat(e.target.value)
                                          : null
                                      }
                                    },
                                    variables: {
                                      productId: pc.node.product.id,
                                      salesChannelId: pc.node.salesChannelId,
                                      input: {
                                        sortOrder: e.target.value
                                          ? parseFloat(e.target.value)
                                          : null
                                      }
                                    }
                                  });
                                }}
                              />
                            </Grid>
                            <Grid
                              onClick={() => {
                                window.open(
                                  '/admin/' +
                                    shopId +
                                    '/inventory/products/' +
                                    pc.node.product.id
                                );
                              }}
                              item
                              xs={1}
                            >
                              {pc.node.product.media &&
                              pc.node.product.media.find(
                                m => m && m.isThumbnail === true
                              ) &&
                              pc.node.product.media.find(
                                m => m && m.isThumbnail === true
                              ).image &&
                              pc.node.product.media
                                .find(m => m && m.isThumbnail === true)
                                .image.indexOf('undefined') === -1 ? (
                                <Imgix
                                  height={28}
                                  width={28}
                                  htmlAttributes={{
                                    alt: '',
                                    style: {
                                      cursor: 'pointer',
                                      marginRight: '8px',
                                      marginLeft: '8px',
                                      float: 'left',
                                      width: '28px',
                                      height: '28px',
                                      objectFit: 'contain'
                                    }
                                  }}
                                  src={pc.node.product.media
                                    .find(m => m && m.isThumbnail === true)
                                    .image.replace(MEDIA_CDN_URL, IMGIX_URL)}
                                  imgixParams={{
                                    auto: 'compress'
                                  }}
                                />
                              ) : null}
                            </Grid>
                            <Grid
                              item
                              xs={8}
                              style={{
                                cursor: 'pointer',
                                width: '100%',
                                border: '1px solid',
                                backgroundColor: secondary,
                                color: '#fff',
                                borderRadius: 3,
                                display: 'flex',
                                alignContent: 'center',
                                padding: 4,
                                position: 'relative'
                              }}
                            >
                              <Typography
                                onClick={() => {
                                  window.open(
                                    '/admin/' +
                                      shopId +
                                      '/inventory/products/' +
                                      pc.node.product.id
                                  );
                                }}
                                style={{ padding: 4 }}
                              >
                                {pc.node.product.title
                                  ? getTextFromLanguage(
                                      pc.node.product.title.text,
                                      defaultLanguage
                                    )
                                    ? getTextFromLanguage(
                                        pc.node.product.title.text,
                                        defaultLanguage
                                      )
                                    : getTextFromLanguage(
                                        pc.node.product.title.text,
                                        'fr_FR'
                                      )
                                    ? getTextFromLanguage(
                                        pc.node.product.title.text,
                                        'fr_FR'
                                      )
                                    : getTextFromLanguage(
                                        pc.node.product.title.text,
                                        'nl_NL'
                                      )
                                    ? getTextFromLanguage(
                                        pc.node.product.title.text,
                                        'nl_NL'
                                      )
                                    : pc.node.product.name
                                    ? pc.node.product.name
                                    : pc.node.productId
                                  : 'N/A'}{' '}
                                ({pc.node.product.no})
                              </Typography>
                            </Grid>
                            <Grid item xs={1}>
                              <Mutation
                                mutation={ADMIN_DELETE_PRODUCT_SALESCHANNEL}
                                update={(
                                  cache,
                                  { data: { deleteProductSalesChannel } }
                                ) => {
                                  if (deleteProductSalesChannel) {
                                    const data = cache.readQuery({
                                      query: ADMIN_GET_TEAMSTORE,
                                      variables: { id: teamstore.id }
                                    });
                                    data.teamstore.products.edges = data.teamstore.products.edges.filter(
                                      c =>
                                        c.node.product.id !== pc.node.product.id
                                    );
                                    cache.writeQuery({
                                      query: ADMIN_GET_TEAMSTORE,
                                      variables: { id: teamstore.id },
                                      data
                                    });
                                  }
                                }}
                              >
                                {(
                                  deleteProductSalesChannel,
                                  { data, loading, error }
                                ) => {
                                  return (
                                    <Button
                                      onClick={async () => {
                                        if (pc) {
                                          await deleteProductSalesChannel({
                                            optimisticResponse: {
                                              __typename: 'Mutation',
                                              deleteProductSalesChannel: true
                                            },
                                            variables: {
                                              productId: pc.node.product.id,
                                              salesChannelId: teamstore.id
                                            }
                                          });
                                        }
                                      }}
                                      color="primary"
                                      variant="contained"
                                      style={{ minWidth: 0, width: '100%' }}
                                    >
                                      <DeleteIcon />
                                    </Button>
                                  );
                                }}
                              </Mutation>
                            </Grid>
                          </Grid>
                        ) : null
                      )
                    ) : null}
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          );
        }}
      </Mutation>
    );
  }
}

export default TeamstoreAssignedProducts;
